import Model from '../../model'

export default class Tag extends Model {
    resource()
    {
        return 'tags'
    }
}
